<template>
	<section class="knd-sticky" ref="story">
		<slot name="before" />

		<figure class="sticky sticky-graphic">
			<slot name="sticky" />
		</figure>
		<div class="steps steps--graphic">
			<slot name="steps" />
		</div>

		<slot name="after" />
	</section>
</template>

<script>
	import enterView from 'enter-view';
	import Stickyfill from 'stickyfilljs';

	const vueObject = {
		props: {
			id: String,
			offset: {
				default: 0.5,
				type: Number,
			},
			once: {
				default: false,
				type: Boolean,
			},			
			triggerClass: {
				default: 'step',
				type: String,
			},
			ActiveClass: {
				default: 'active',
				type: String,
			}
		},
		data: function() {
			return {
				activeIndex: undefined,
				activeElement: undefined
			}
		},
		mounted: function () {
			this.storyRef = this.$refs.story;
			this.setupEnterview();
		},

		methods: {
			setupEnterview() {
				this.steps = this.storyRef.querySelectorAll(`.${this.triggerClass}`);

				// add index to each element through data attribute
				this.loopElements(this.steps, (el, i) => { el.setAttribute('data-index', i) });

				// Polyfill for IE 9-11
				Stickyfill.add(document.querySelector('.sticky-graphic'));

				const enterviewObj = {
					selector: this.steps,
					enter: (el) => this.enterView(el),
					exit: (el) => this.exitView(el),
					once: this.once,
					progress: (el, progress) => this.progressUpdate(progress),
					offset: this.offset
				};

				enterView(enterviewObj);
			},

			enterView(el) {
				const index = +el.dataset.index;

				this.updateIndex(index);
				this.update();

				this.$emit('enterFn', el);
			},

			exitView(el) {
				const index = +el.dataset.index;

				// set previous element as activeclass
				const prevIndex = Math.max(0, index -1);
				this.updateIndex(prevIndex);
				this.update();

				this.$emit('enterFn', this.activeElement);
				this.$emit('exitFn', el);
			},

			progressUpdate(progress) {
				this.$emit('progressFn', progress);
			},

			updateIndex(index) {
				this.activeIndex = index;
				this.activeElement = this.getElementOnIndex(index);
			},

			getElementOnIndex(index) {
				return this.storyRef.querySelector(`[data-index="${index}"]`);
			},

			update() {
				this.loopElements(this.steps, (el, i) => { 
					// el.classList.remove(this.ActiveClass, 'step-prev', 'step-next');
					el.classList.remove('step-prev', 'step-next');
				});

				this.addClass(this.activeElement, this.ActiveClass)

				this.updatePrevNext();
			},

			updatePrevNext() {
				let prevEl = this.getElementOnIndex(this.activeIndex - 1);
				this.addClass(prevEl, 'step-prev');

				let nextEl = this.getElementOnIndex(this.activeIndex + 1);
				this.addClass(nextEl, 'step-next');
			},

			addClass(el, className) {
				if (el) {
					el.classList.add(className);
				}
			},

			loopElements(elements, cb) {
				for (let i = 0; i < elements.length; i++) {
					cb(elements[i], i);
				}
			}
		}
	}

	export default vueObject;
</script>